
import * as React from "react"
import { cn } from "@/lib/utils"
import { useSidebar } from "./sidebar-provider"

const Sidebar = ({ className, children, ...props }: React.HTMLAttributes<HTMLElement>) => {
  const { isCollapsed, isMobile, setCollapsed } = useSidebar()

  if (isMobile) {
    return (
      <>
        {/* Backdrop overlay */}
        {!isCollapsed && (
          <div
            className="fixed inset-0 z-40 bg-black/50"
            onClick={() => setCollapsed(true)}
          />
        )}
        <aside
          className={cn(
            "fixed inset-y-0 left-0 z-50 flex flex-col w-[250px] bg-secondary border-r transition-transform duration-300",
            isCollapsed ? "-translate-x-full" : "translate-x-0",
            className
          )}
          {...props}
        >
          {children}
        </aside>
      </>
    )
  }

  return (
    <aside 
      className={cn(
        "flex flex-col h-screen bg-secondary border-r transition-all duration-300", 
        isCollapsed ? "w-0 overflow-hidden opacity-0" : "w-[250px]",
        className
      )} 
      {...props}
    >
      {children}
    </aside>
  )
}
Sidebar.displayName = "Sidebar"

export { Sidebar }
